import React, { useEffect, useState, Fragment } from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import { Dialog, Transition } from "@headlessui/react";

const formatCount = (count) => {
    if (count >= 1000) {
        return `${Math.floor(count / 1000)}k+`;
    }
    return count;
};

const FixedThumbsUpDownButton = ({
    appId,
    titleGood,
    titleBad,
    titleRateTheService,
    titleFeedback,
    titleSend,
    titleClose,
    titleTypeYourMessageHere,
    titleExplainPlease,
}) => {
    const [plusCount, setPlusCount] = useState(0);
    const [minusCount, setMinusCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [showAdditionalMessage, setShowAdditionalMessage] = useState(false);
    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post("/getRating", { appId });
                console.log(response.data);
                setPlusCount(response.data.plus);
                setMinusCount(response.data.minus);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [appId]);

    const handleRating = async (rating) => {
        try {
            const response = await axios.post("/setRating", { appId, rating });

            setOpen(true);

            if (rating === "minus") {
                setShowAdditionalMessage(true);
            } else {
                setShowAdditionalMessage(false);
            }

            const getRatingResponse = await axios.post("/getRating", { appId });

            setPlusCount(getRatingResponse.data.plus);
            setMinusCount(getRatingResponse.data.minus);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmitFeedback = async () => {
        try {
            const textareaValue =
                document.getElementById("feedback-textarea").value;

            const feedbackResponse = await axios.post("/setFeedback", {
                appId,
                feedback: textareaValue,
            });

            console.log(feedbackResponse.data);

            setOpen(false);
        } catch (error) {
            console.error(error);

            setOpen(false);
        }
    };

    const handleCloseFeedback = () => {
        setOpen(false);
    };

    useEffect(() => {
        const handleWindowResize = () => {
            setShouldShow(window.innerWidth < 1000 && window.innerWidth > 380);
        };

        window.addEventListener("resize", handleWindowResize);
        handleWindowResize();

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    if (!shouldShow) {
        return null;
    }

    return (
        <Fragment>
            <div
                className="fixed-widget"
                style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "30px",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    paddingRight: "10px",
                    marginRight: "10px",
                }}
            >
                <div
                    className="feedback-container-fix"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: "20px",
                    }}
                >
                    <button
                        type="button"
                        className="feedback-button positive"
                        onClick={() => handleRating("plus")}
                        title={titleGood}
                        style={{
                            width: "30px",
                            height: "30px",
                            fontSize: "24px",
                            textAlign: "center",
                            borderRadius: "50%",
                            /* backgroundColor: "lightgreen", */
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        &#128293;
                    </button>
                    <span
                        className="feedback-count-fix"
                        style={{
                            marginLeft: "10px",
                            fontSize: "14px",
                            /* display: "none", */
                        }}
                    >
                        {formatCount(plusCount)}
                    </span>
                </div>
                <div
                    className="feedback-container-fix"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "10px",
                    }}
                >
                    <button
                        type="button"
                        className="feedback-button negative"
                        onClick={() => handleRating("minus")}
                        title={titleBad}
                        style={{
                            width: "30px",
                            height: "30px",
                            fontSize: "24px",
                            textAlign: "center",
                            borderRadius: "50%",
                            /* backgroundColor: "lightcoral", */
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        &#10052;
                    </button>
                    <span
                        className="feedback-count-fix"
                        style={{
                            marginLeft: "10px",
                            fontSize: "14px",
                            /* display: "none", */
                        }}
                    >
                        {formatCount(minusCount)}
                    </span>
                </div>
            </div>
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 overflow-hidden"
                    onClose={handleCloseFeedback}
                >
                    <div className="absolute inset-0 overflow-hidden">
                        <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300" />
                        <div className="fixed inset-0 overflow-hidden flex items-center justify-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-in-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in-out duration-300"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="h-70vh w-full md:w-1/2 mx-auto my-0 md:my-8 bg-white rounded-lg shadow-xl transform transition-transform duration-300">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg leading-6 font-medium text-gray-900 p-4 flex justify-between items-center"
                                    >
                                        {titleFeedback}
                                        <button
                                            onClick={handleCloseFeedback}
                                            className="p-2 rounded-full hover:bg-gray-200 focus:outline-none"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-gray-500 hover:text-gray-700"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.293 5.293a1 1 0 011.414 0L10 8.586l3.293-3.293a1 1 0 011.414 1.414L11.414 10l3.293 3.293a1 1 0 01-1.414 1.414L10 11.414l-3.293 3.293a1 1 0 01-1.414-1.414L8.586 10 5.293 6.707a1 1 0 010-1.414z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </button>
                                    </Dialog.Title>
                                    <div className="p-4">
                                        {titleTypeYourMessageHere}
                                        <textarea
                                            id="feedback-textarea"
                                            className="w-full p-2 border border-gray-300 rounded h-3/4 resize-none"
                                            placeholder=""
                                        />
                                        <button
                                            onClick={handleSubmitFeedback}
                                            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
                                        >
                                            {titleSend}
                                        </button>
                                        {showAdditionalMessage && (
                                            <p className="text-gray-500 mt-4">
                                                {titleExplainPlease}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    );
};

export default FixedThumbsUpDownButton;

const fixedThumbsUpDownButtonElement = document.querySelector(
    ".fixed-thumbs-up-down"
);

if (fixedThumbsUpDownButtonElement) {
    const appId = fixedThumbsUpDownButtonElement.getAttribute("data-appid");
    const titleRateTheService = fixedThumbsUpDownButtonElement.getAttribute(
        "titleRateTheService"
    );
    const titleFeedback =
        fixedThumbsUpDownButtonElement.getAttribute("titleFeedback");
    const titleSend = fixedThumbsUpDownButtonElement.getAttribute("titleSend");
    const titleClose =
        fixedThumbsUpDownButtonElement.getAttribute("titleClose");
    const titleTypeYourMessageHere =
        fixedThumbsUpDownButtonElement.getAttribute("titleTypeYourMessageHere");
    const titleExplainPlease =
        fixedThumbsUpDownButtonElement.getAttribute("titleExplainPlease");
    const titleGood = fixedThumbsUpDownButtonElement.getAttribute("titleGood");
    const titleBad = fixedThumbsUpDownButtonElement.getAttribute("titleBad");

    const root = createRoot(fixedThumbsUpDownButtonElement);
    root.render(
        <FixedThumbsUpDownButton
            appId={appId}
            titleRateTheService={titleRateTheService}
            titleFeedback={titleFeedback}
            titleTypeYourMessageHere={titleTypeYourMessageHere}
            titleSend={titleSend}
            titleClose={titleClose}
            titleExplainPlease={titleExplainPlease}
            titleGood={titleGood}
            titleBad={titleBad}
        />
    );
}
